// AI 내담자 활동 목록 응답을 화면용 형태로 바꾸는 도우미 모음.
// 목록 응답 필드가 확정되지 않아 후보 필드를 함께 읽는다. 필드가 확정되면 toActivity만 맞춘다.

export const statusLabels = { completed: '완료', active: '진행 중', prepared: '준비됨' };

const pad = value => String(value).padStart(2, '0');

// 밀리초 숫자나 ISO 문자열을 YYYY.MM.DD로 바꾼다. 읽을 수 없으면 '—'.
export function formatDate(value) {
    const date = new Date(value);
    if (value == null || Number.isNaN(date.getTime())) return '—';
    return `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())}`;
}

// 날짜 값을 정렬용 밀리초 숫자로 바꾼다. 읽을 수 없으면 0.
function toTime(value) {
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? 0 : time;
}

// 목록 응답 항목 하나를 화면에서 쓰는 활동 객체로 정리한다.
export function toActivity(item = {}) {
    const client = item.client || {};
    const date = item.completedAt ?? item.startedAt ?? item.createdAt;
    return {
        instanceId: item.instanceId ?? item.id,
        clientId: String(client.id ?? item.profileId ?? client.name ?? ''),
        client,
        clientName: client.name || item.clientName || '내담자',
        title: client.title || '',
        status: item.status,
        durationMinutes: item.durationMinutes,
        date,
        time: toTime(date),
    };
}

// 활동 목록을 최근 순으로 정렬한 화면용 배열로 만든다. instanceId가 없는 항목은 뺀다.
export function toActivities(items) {
    return items.map(toActivity).filter(item => item.instanceId != null).sort((a, b) => b.time - a.time);
}

// 피드백 리포트 상단(ReviewLayout)에 넘길 면담 정보를 만든다.
export function toReviewSession(activity, feedback) {
    const { client = {} } = activity || {};
    const profile = [client.age && `${client.age}세`, client.occupation].filter(Boolean).join(' · ');
    return {
        name: activity?.clientName || '내담자',
        profile,
        title: activity?.title || '',
        date: formatDate(feedback?.createdAt ?? activity?.date),
        duration: activity?.durationMinutes ? `${activity.durationMinutes}분` : '—',
        model: 'MI · 동기면담',
    };
}
